import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_na6tfqypxs: FaireBrandEntity = {
  token: "b_na6tfqypxs",
  type: "brand",
  name: "Triple Goddess Boutique",
  avatarUrl:
    "https://cdn.faire.com/fastly/de71c7224f18d673db0024d6823ef253b2f5d4a8528032da4c92ca66ed8c869f.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/29644286f0883a3aef18ddf32210fdb33927ba63ac09a97e921891058c56a5a8.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/de71c7224f18d673db0024d6823ef253b2f5d4a8528032da4c92ca66ed8c869f.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/29644286f0883a3aef18ddf32210fdb33927ba63ac09a97e921891058c56a5a8.jpeg",
  location: "Butler, PA, USA",
  minimumOrderDollars: 39,
  rating: 5,
  reviewCount: 8,
  isInsider: true,
  description:
    "Triple Goddess Boutique provides trending products that empower your well being and bring a little magic into your lifestyle.\nTriple Goddess Boutique's exclusive pocket leggings were designed to help you express yourself how you want in our printed leggings. Leggings are a staple to any wardrobe and with our collection we design prints that can't be found anyhwhere else from Spirituality, symbols and occult. There's something for everyone, so you can truly be yourself. We didn't leave out the important details like great sizing, pockets that work and never see through!\n\nI started selling leggings in 2017 for another company, after a year, I decided I wanted to sell them on my own and went for it. After a few years, the legging prints were beginning to become bored and I noticed there was so many gaps in the designs of things women wanted to see in leggings, at the time alot of the population was beginning to go deeper into spirituality, wellness, crystals and healing, including myself. Thats when I dreamed of starting my own brand of leggings for \"Witch's\", \"Spiritualists\", \"gothics\" and people who just enjoy expressing themselves, that's where TGB Leggings were born, and we had to have pockets, no pockets those days were over! With 10 years now in the legging industry, I won't let you down, I promise you'll love TGB leggings and your customers will too!\n",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:52:44.925Z",
    importedBy: "entity-db-cli",
  },
};
